export type OdinModuleId = 'base' | 'norwegians' | 'solo';

export const odinMetadata = {
  id: 'a-feast-for-odin',
  slug: 'a-feast-for-odin',
  title: 'Uczta dla Odyna',
  subtitle: 'Pełna instrukcja z dodatkiem Norwegowie',
  designer: 'Uwe Rosenberg',
  playerCount: { min: 1, max: 4 },
  recommendedPlayerCount: 3,
  durationMinutes: { min: 90, max: 180 },
  complexity: 4,
  defaultConfiguration: {
    playerCount: 3,
    activeModuleIds: ['base', 'norwegians'] as OdinModuleId[],
  },
  modules: [
    {
      id: 'base',
      title: 'Gra podstawowa',
      required: true,
      status: 'partial',
      description:
        'Procedury gry podstawowej (Rewrite 3.0). Katalogi ikon pól i kart — PARTIAL.',
    },
    {
      id: 'norwegians',
      title: 'Norwegowie',
      required: false,
      status: 'partial',
      description:
        'Jeden rozdział dodatku: plansze, 5. kolumna, zwierzęta, szopy, grabież, mała emigracja.',
    },
    {
      id: 'solo',
      title: 'Wariant solo',
      required: false,
      status: 'partial',
      description: 'Blokowanie pól własnymi wikingami z poprzedniej rundy.',
    },
  ],
} as const;
